import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import moment from "moment";
import { toast } from 'react-toastify';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

/* for "axios" request cancelation */
import axios from 'axios';

/* Helpers */
// import { history } from '../../../helpers/history';
import 'moment/locale/tr';

/* Services */
import AuthService from "../../../services/auth.service";
import DoctorService from "../../../services/doctor.service";

/* Ant Design */
import { Typography, Spin, Select, Divider, Row, Col, Radio, Skeleton, Tabs, Card, Image, Space, Button, Modal, List } from 'antd';

let source;

const ActivityHistory = (props) => {
    const [doctor, setDoctor] = useState();
    const [patient, setPatient] = useState(null);
    const [loadingPatient, setLoadingPatient] = useState(true);

    const [patientGameCount, setPatientGameCount] = useState({});
    const [loadingPatientGameCount, setLoadingPatientGameCount] = useState(true);

    const [calendarRangeValues, setCalendarRangeValues] = React.useState([
        { value: '1', type: 'w', name: '1 Hafta' },
        { value: '1', type: 'm', name: '1 Ay' },
        { value: '3', type: 'm', name: '3 Ay' },
    ]);
    const [calendarRange, setCalendarRange] = React.useState(calendarRangeValues[0].value + calendarRangeValues[0].type);

    const [patientGameDatas, setPatientGameDatas] = useState([]);
    const [patientGameTimeDatas, setPatientGameTimeDatas] = useState([]);
    const [loadingPatientGameDatas, setLoadingPatientGameDatas] = useState(true);

    const [modalVisible, setModalVisible] = useState(false);

    let { patientId } = useParams();

    useEffect(() => {
        source = axios.CancelToken.source();

        setDoctor(AuthService.getCurrentDoctor());
        getPatient(patientId, source.token);

        return () => {
            if (source) {
                source.cancel();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getPatient = (patientId, cancelToken) => {
        if (!patientId) {
            toast.error({ message: "Hasta Bulunamadı!" });
        }

        setLoadingPatient(true);

        DoctorService.getPatient(patientId, cancelToken)
            .then(
                res => {
                    setPatient(res.data);
                    setLoadingPatient(false);
                },
                error => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    if (resMessage !== "Cancel") {
                        toast.error(resMessage);
                        setLoadingPatient(false);
                    }
                }
            )
    }

    useEffect(() => {
        if (patient) {
            if (calendarRange) {
                patientDailyPlayGamesCount(patient._id, calendarRange);
            } else {
                patientDailyPlayGamesCount(patient._id, "1w");
            }
        }
    }, [patient, calendarRange]);

    useEffect(() => {
        if (patient) {
            getPatientGameDatas(patient._id);
        }
    }, [patient]);

    const patientDailyPlayGamesCount = (patientId, range) => {
        setLoadingPatientGameCount(true);

        DoctorService.getPatientDailyPlayGamesCount(patientId, range, source.token).then(
            res => {
                res.data?.map((data, index) => {
                    if (Math.floor(data.TotalPlayedTime) === 0 && data.count > 0) {
                        res.data[index].TotalPlayedTime = Math.floor(data.TotalPlayedTime) + 1;
                    } else {
                        res.data[index].TotalPlayedTime = Math.floor(data.TotalPlayedTime);
                    }
                });
                setPatientGameCount([...res.data]);
                setLoadingPatientGameCount(false);
            },
            error => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                if (resMessage === "Cancel") {
                    setLoadingPatientGameCount(false);
                } else {
                    setPatientGameCount({});
                    setLoadingPatientGameCount(false);
                    toast.error(resMessage);
                }
            });
    };

    const getPatientGameDatas = (patientId) => {
        setLoadingPatientGameDatas(true);

        DoctorService.getPatientGameDatas(patientId, source.token).then(
            res => {
                const reModelledGameDatas = res.data.GameData?.GameDatas?.map(gamedata => {
                    return {
                        ...gamedata,
                        key: gamedata._id,
                        CoordinatesLength: gamedata.Coordinates,
                        SessionTime: gamedata.TotalPlayedTime ? (Math.floor(gamedata.TotalPlayedTime / 60)) : (Math.floor((new Date(gamedata.EndTime) - new Date(gamedata.StartTime)) / 60e3)),
                        StartTime: moment(new Date(gamedata.StartTime)).format('LLL'),
                        EndTime: moment(new Date(gamedata.EndTime)).format('LLL'),
                        TransferTime: moment(new Date(gamedata.TransferTime)).format('LLL'),
                    }
                });
                setPatientGameDatas([...reModelledGameDatas]);
                setPatientGameTimeDatas([...res.data.GameData?.GameTimeDatas]);
                setLoadingPatientGameDatas(false);
            },
            error => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                if (resMessage === "Cancel") {
                    setLoadingPatientGameDatas(false);
                } else {
                    setPatientGameDatas([]);
                    setPatientGameTimeDatas([]);
                    setLoadingPatientGameDatas(false);
                    toast.error(resMessage);
                }
            });
    };

    function handleCalendarSizeChange(e) {
        setCalendarRange(e.target.value);
    }

    let gamesCount = 0;
    let gamesTimesCount = 0;
    let calculationCount = 0;
    let modalVisibleVariable = modalVisible;

    function info(_id, OyunAdi, calculations) {
        calculationCount = 0;
        Modal.info({
            title: OyunAdi,
            visible: (modalVisibleVariable === _id + OyunAdi),
            content: (
                <Row gutter={[8, 32]} style={{ width: '100%' }}>
                    {calculations.map(calculation => {
                        return (
                            <Col span={6}>
                                <List size="larger" bordered style={((calculationCount + 1) % 2 === 0) ? { backgroundColor: '#e6f7ff' } : { backgroundColor: '#fff' }}>
                                    <List.Item>
                                        <Typography.Title level={5}><b>{calculationCount + 1}.&nbsp;Köşe</b></Typography.Title>
                                    </List.Item>
                                    {/* FOCSR - FOCSRNumerator */}
                                    <List.Item>
                                        <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                            <Col span={12}>
                                                <Typography.Text style={{ fontWeight: 'bold' }}>FOCSR: </Typography.Text>
                                                <Typography.Text>{calculation.FOCSR}</Typography.Text>
                                            </Col>
                                            <Col span={12}>
                                                <Typography.Text style={{ fontWeight: 'bold' }}>FOCSRNumerator: </Typography.Text>
                                                <Typography.Text>{calculation.FOCSRNumerator}</Typography.Text>
                                            </Col>
                                        </Row>
                                    </List.Item>
                                    {/* FOCSRDenominator - FOTA */}
                                    <List.Item>
                                        <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                            <Col span={12}>
                                                <Typography.Text style={{ fontWeight: 'bold' }}>FOCSRDenominator: </Typography.Text>
                                                <Typography.Text>{calculation.FOCSRDenominator}</Typography.Text>
                                            </Col>
                                            <Col span={12}>
                                                <Typography.Text style={{ fontWeight: 'bold' }}>FOTA: </Typography.Text>
                                                <Typography.Text>{calculation.FOTA}</Typography.Text>
                                            </Col>
                                        </Row>
                                    </List.Item>
                                    {/* FOTANumerator - FOTADenominator */}
                                    <List.Item>
                                        <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                            <Col span={12}>
                                                <Typography.Text style={{ fontWeight: 'bold' }}>FOTANumerator: </Typography.Text>
                                                <Typography.Text>{calculation.FOTANumerator}</Typography.Text>
                                            </Col>
                                            <Col span={12}>
                                                <Typography.Text style={{ fontWeight: 'bold' }}>FOTADenominator: </Typography.Text>
                                                <Typography.Text>{calculation.FOTADenominator}</Typography.Text>
                                            </Col>
                                        </Row>
                                    </List.Item>
                                    {/* FOTSR - FOTSRNumerator */}
                                    <List.Item>
                                        <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                            <Col span={12}>
                                                <Typography.Text style={{ fontWeight: 'bold' }}>FOTSR: </Typography.Text>
                                                <Typography.Text>{calculation.FOTSR}</Typography.Text>
                                            </Col>
                                            <Col span={12}>
                                                <Typography.Text style={{ fontWeight: 'bold' }}>FOTSRNumerator: </Typography.Text>
                                                <Typography.Text>{calculation.FOTSRNumerator}</Typography.Text>
                                            </Col>
                                        </Row>
                                    </List.Item>
                                    {/* FOTSRDenominator - AFOFT */}
                                    <List.Item>
                                        <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                            <Col span={12}>
                                                <Typography.Text style={{ fontWeight: 'bold' }}>FOTSRDenominator: </Typography.Text>
                                                <Typography.Text>{calculation.FOTSRDenominator}</Typography.Text>
                                            </Col>
                                            <Col span={12}>
                                                <Typography.Text style={{ fontWeight: 'bold' }}>AFOFT: </Typography.Text>
                                                <Typography.Text>{calculation.AFOFT}</Typography.Text>
                                            </Col>
                                        </Row>
                                    </List.Item>
                                    {/* AFOFTNumerator - AFOFTDenominator */}
                                    <List.Item>
                                        <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                            <Col span={12}>
                                                <Typography.Text style={{ fontWeight: 'bold' }}>AFOFTNumerator: </Typography.Text>
                                                <Typography.Text>{calculation.AFOFTNumerator}</Typography.Text>
                                            </Col>
                                            <Col span={12}>
                                                <Typography.Text style={{ fontWeight: 'bold' }}>AFOFTDenominator: </Typography.Text>
                                                <Typography.Text>{calculation.AFOFTDenominator}</Typography.Text>
                                            </Col>
                                        </Row>
                                    </List.Item>
                                </List>
                                <p style={{ display: 'none' }}>{calculationCount++}</p>
                            </Col>
                        )
                    })}
                </Row>
            ),
            onOk() { },
            width: '100%'
        })
    }

    return (
        <div>
            <Skeleton loading={loadingPatient} active>
                <div>
                    <Typography.Title style={{ textAlign: 'center' }}>
                        {patient ? ('"' + patient.AdSoyad + '" ') : ''} Aktivite Geçmişi
                    </Typography.Title>
                    <Divider />
                    {/* Haftalık Oyun Oynama Bilgileri */}
                    <Row gutter={[16, 32]} style={{ width: '100%' }}>
                        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                            <div style={{ textAlign: 'end', marginBottom: "2vh" }}>
                                <Radio.Group value={calendarRange} onChange={handleCalendarSizeChange}>
                                    {calendarRangeValues.map(value =>
                                        <Radio.Button key={value.value + value.type} value={value.value + value.type}>{value.name}</Radio.Button>
                                    )}
                                </Radio.Group>
                            </div>
                            <Skeleton loading={loadingPatientGameCount} active>
                                <div>
                                    <ResponsiveContainer width={'100%'} height={400}>
                                        <AreaChart
                                            width={500}
                                            height={400}
                                            data={patientGameCount}
                                            margin={{
                                                top: 5,
                                                bottom: 5,
                                            }}
                                        >
                                            <defs>
                                                <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                                    <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
                                                    <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
                                                </linearGradient>
                                                <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                                                    <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
                                                    <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
                                                </linearGradient>
                                            </defs>
                                            <XAxis
                                                dataKey="date"
                                                tickFormatter={(value, index) => {
                                                    if (value) {
                                                        value = value.split(' ');
                                                        return value[0] + ' ' + value[1];
                                                    }
                                                }}
                                            />
                                            <YAxis />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Tooltip cursor={{ fill: 'transparent' }} />
                                            <Area type="monotone" dataKey="count" name="Toplam Oturum Sayısı" stroke="#8884d8" fillOpacity={1} fill="url(#colorUv)" />
                                            <Area type="monotone" dataKey="TotalPlayedTime" name="Toplam Oynama Süresi(dk)" stroke="#82ca9d" fillOpacity={1} fill="url(#colorPv)" />
                                        </AreaChart>
                                    </ResponsiveContainer>
                                </div>
                            </Skeleton>
                        </Col>
                    </Row>
                </div>
            </Skeleton>
            <Skeleton loading={loadingPatientGameDatas} active>
                {!loadingPatientGameDatas && patientGameDatas.length > 0 &&
                    <div>
                        <Divider />
                        <Tabs defaultActiveKey="1">
                            <Tabs.TabPane tab="Oyun Verileri" key="1">
                                <div style={{ minHeight: 400, maxHeight: 400, overflowY: 'scroll', overflowX: 'hidden' }}>
                                    <Row gutter={[8, 32]} style={{ marginTop: '2vh', marginRight: '1vh' }}>
                                        <p style={{ display: 'none' }}>{gamesCount = 0}</p>
                                        {patientGameDatas?.map(gamedata => (
                                            <Col xs={24} md={12} lg={8} xl={6} xxl={4} key={gamedata._id} style={{ display: 'flex' }}>
                                                <Card
                                                    size="small"
                                                    cover={
                                                        <Image
                                                            preview={false}
                                                            width={'100%'}
                                                            src={gamedata.GameID.PhotoLink}
                                                            alt={gamedata.GameID.OyunAdi}
                                                            fallback="data:image/png;base64,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"
                                                        />
                                                    }
                                                    style={((gamesCount + 1) % 2 === 0) ? {
                                                        backgroundColor: '#e6f7ff', borderRadius: "20px",
                                                        overflow: "hidden"
                                                    } : {
                                                        backgroundColor: '#FFFFFF', borderRadius: "20px",
                                                        overflow: "hidden"
                                                    }}
                                                >
                                                    <Card.Meta
                                                        title={
                                                            <Tooltip title={gamedata.GameID.OyunAdi}>
                                                                <Typography.Title level={5}>
                                                                    <Typography.Text style={{ fontWeight: 'bold' }}>{gamesCount + 1}) {gamedata.GameID.OyunAdi}</Typography.Text>
                                                                </Typography.Title>
                                                            </Tooltip>
                                                        }
                                                        description={
                                                            <div>
                                                                <Typography>
                                                                    <Typography.Text><b>Koordinat Sayısı: </b>{gamedata.CoordinatesLength}</Typography.Text>
                                                                    <br />
                                                                    <Typography.Text><b>Oturum Süresi: </b>{gamedata.SessionTime < 1 ? '1' : gamedata.SessionTime} dk</Typography.Text>
                                                                    <br />
                                                                    <Typography.Text><b>Başlangıç Zamanı: </b>{gamedata.StartTime}</Typography.Text>
                                                                    <br />
                                                                    <Typography.Text><b>Bitiş Zamanı: </b>{gamedata.EndTime}</Typography.Text>
                                                                    <br />
                                                                    <Typography.Text><b>Transfer Zamanı: </b>{gamedata.TransferTime}</Typography.Text>
                                                                </Typography>
                                                                <Divider />
                                                            </div>
                                                        }
                                                    />
                                                    <Space style={{ width: '100%', justifyContent: 'center' }}>
                                                        {gamedata.Calculations.length > 0 ?
                                                            <Button type='primary' onClick={() => { setModalVisible(gamedata._id + gamedata.GameID.OyunAdi); info(gamedata._id, gamedata.GameID.OyunAdi, gamedata.Calculations); }} style={{ width: '100%' }} block>Hesaplamaları Göster</Button>
                                                            :
                                                            <Button type='primary' disabled={true} style={{ width: '100%' }} block>Hesaplamaları Göster</Button>
                                                        }
                                                    </Space>
                                                </Card>
                                                <p style={{ display: 'none' }}>{gamesCount += 1}</p>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="Toplam Oynama Süreleri" key="2">
                                <div style={{ minHeight: 400, maxHeight: 400, overflowY: 'scroll', overflowX: 'hidden' }}>
                                    <Row gutter={[8, 32]} style={{ marginTop: '2vh', marginRight: '1vh' }}>
                                        <p style={{ display: 'none' }}>{gamesTimesCount = 0}</p>
                                        {patientGameTimeDatas?.map(gameTimeData => (
                                            <Col xs={24} md={12} lg={8} xl={6} xxl={4} key={gameTimeData._id} style={{ display: 'flex' }}>
                                                <Card
                                                    size="small"
                                                    cover={
                                                        <Image
                                                            preview={false}
                                                            width={'100%'}
                                                            src={gameTimeData.PhotoLink}
                                                            alt={gameTimeData.OyunAdi}
                                                            fallback="data:image/png;base64,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"
                                                        />
                                                    }
                                                    style={((gamesTimesCount + 1) % 2 === 0) ? {
                                                        backgroundColor: '#e6f7ff', borderRadius: "20px",
                                                        overflow: "hidden"
                                                    } : {
                                                        backgroundColor: '#FFFFFF', borderRadius: "20px",
                                                        overflow: "hidden"
                                                    }}
                                                >
                                                    <Card.Meta
                                                        title={
                                                            <Tooltip title={gameTimeData.OyunAdi}>
                                                                <Typography.Title level={5}>
                                                                    <Typography.Text style={{ fontWeight: 'bold' }}>{gamesTimesCount + 1}) {gameTimeData.OyunAdi}</Typography.Text>
                                                                </Typography.Title>
                                                            </Tooltip>
                                                        }
                                                        description={
                                                            <Typography>
                                                                <Typography.Text><b>Toplam Oynama Süresi: </b>{Math.floor(gameTimeData.TotalPlayedTime / 60) > 0 ? (Math.floor(gameTimeData.TotalPlayedTime / 60) + " dk") : "1 dk'dan az"}</Typography.Text>
                                                            </Typography>
                                                        }
                                                    />
                                                </Card>
                                                <p style={{ display: 'none' }}>{gamesTimesCount += 1}</p>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            </Tabs.TabPane>
                        </Tabs>
                    </div>
                }
            </Skeleton>
        </div>
    )
}

const mapState = (state) => ({
});

const mapDispatch = (dispatch) => ({
});

export default connect(mapState, mapDispatch)(ActivityHistory);